import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-up', 'ArrowUp', [["path",{"d":"M12 19.5v-15m0 0-6 5.625M12 4.5l6 5.625","key":"svg-0"}]]);